import React from 'react';

import { createFormField } from 'Shared/utils/createFormField';
import { Field } from 'react-final-form';
import FormSelect from 'Shared/components/FormComponents/FormSelect';
import { formatWorkspaceTitle } from 'Shared/helpers';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  nonTeamSyncWorkspacesWithInitialTeammate;
};

import './FormSelectWorkspace.scss';

function SelectWorkspace({ nonTeamSyncWorkspacesWithInitialTeammate }: Props) {
  const { user: currentUser } = useCurrentUser();
  const workspaceOptions = nonTeamSyncWorkspacesWithInitialTeammate?.map(workspace => {
    return { value: workspace.id, label: formatWorkspaceTitle({ workspace, user: currentUser }) };
  });

  return (
    <div className="form-select-workspace">
      Workspace
      <Field
        name="workspaceId"
        placeholder="Select workspace"
        className="ml-2 form-select-workspace-selector"
        menuPortalTarget={document.body}
        customStyles={{ menuPortal: base => ({ ...base, zIndex: '1050' }) }}
        options={workspaceOptions}
        component={FormSelect}
        isClearable={false}
      />
    </div>
  );
}

export default createFormField(SelectWorkspace);
